import { render, staticRenderFns } from "./shopee-operation.vue?vue&type=template&id=7bd20b7f&scoped=true&"
import script from "./shopee-operation.vue?vue&type=script&lang=js&"
export * from "./shopee-operation.vue?vue&type=script&lang=js&"
import style0 from "./shopee-operation.vue?vue&type=style&index=0&id=7bd20b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd20b7f",
  null
  
)

export default component.exports